import React from 'react';
import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { turfNaming } from '../../../../api/typesDc';
import { ClubNameCell } from '../finance/academyTableComponent';

const FacilitiesSubTableComponent: React.FC<any> = React.memo(({ clubData, setSelectedRow }:any) => {
  const [t] = useTranslation();
  return (
    clubData && (
      <TableContainer className={'table-container'} sx={{ backgroundColor: '#f3f6fb', maxHeight: 300 }}>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <div
            style={{
              backgroundColor: '#f3f6fb',
              fontSize: '16px',
              fontWeight: 'bold',
              paddingBottom: '5px',
            }}
          >
            <ClubNameCell clubData={clubData} getImageUrl={(data:any) => data?.club?.imagePath} />
          </div>
          <div style={{ alignSelf: 'center', paddingRight: '10px' }}>
            <Tooltip title={'Close'}>
              <FontAwesomeIcon
                className="icon ml10"
                icon={faClose}
                style={{ cursor: 'pointer', fontSize: 18 }}
                onClick={() => setSelectedRow(null)}
              />
            </Tooltip>
          </div>
        </div>
        <Divider />
        <Table stickyHeader aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold', minWidth: '150px' }}>
                {t('DC_5_CLUB')}
              </TableCell>
              <TableCell style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold' }}>{t('DC_6_FACILITY')}</TableCell>
              <TableCell style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold', minWidth: '150px' }}>
                {t('NAME')}
              </TableCell>
              <TableCell
                style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold', textAlign: 'center', whiteSpace: 'nowrap' }}
              >
                {t('DC_6_WIDTH')}
              </TableCell>
              <TableCell
                style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold', textAlign: 'center', whiteSpace: 'nowrap' }}
              >
                {t('DC_6_DEPTH')}
              </TableCell>
              <TableCell style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold', textAlign: 'center' }}>
                {t('DC_6_SPECTATORS')}
              </TableCell>
              <TableCell style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold' }}>{t('DC_6_TURF')}</TableCell>
              <TableCell style={{ backgroundColor: '#f3f6fb', fontWeight: 'bold', textAlign: 'center' }}>
                {t('ILLUMINATION')}
              </TableCell>
            </TableRow>
          </TableHead>
          <>
            {clubData?.facilityGrounds?.map((item:any, index:any) => (
              <TableRow key={index}>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px' }}>{clubData.facilityName} </TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px' }}>{clubData.shortName}</TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px' }}>{item.name}</TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px', textAlign: 'center' }}>{item.width}</TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px', textAlign: 'center' }}>{item.depth}</TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px', textAlign: 'center' }}>
                  {item.spectators}
                </TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px' }}>
                  {t(turfNaming[item.turf?.toString()])}
                </TableCell>
                <TableCell style={{ fontSize: '0.75rem', padding: '8px', textAlign: 'center' }}>
                  {item.illumination?.toString()}
                </TableCell>
              </TableRow>
            ))}
          </>
        </Table>
      </TableContainer>
    )
  );
});

export default FacilitiesSubTableComponent;
